import React from 'react';
import { useProperty } from '@spotify-internal/remote-config-integration-react';

import { feedbackPositionEnum, FeedbackPositions } from 'utils/remote-config/properties';

/**
 * HOC to show/hide a component based on the remote property allocation
 * for the `feedback-position` experiment
 * @param WrappedComponent Component to be shown
 * @param positions List of property values to be match
 */
const withFeedbackPositionExperiment = <Props extends {}>(
  WrappedComponent: React.ComponentType<Props>,
  positions: FeedbackPositions[],
): React.ComponentType<Props> => {
  return (props: Props) => {
    const feedbackPosition = useProperty(feedbackPositionEnum, { loadingValue: FeedbackPositions.CURRENT });
    const shouldShow = positions.includes(feedbackPosition);

    return shouldShow ? <WrappedComponent {...props} isSticky={feedbackPosition === FeedbackPositions.STICKY} /> : null;
  };
};

export default withFeedbackPositionExperiment;
